import { ClaimsFormData } from '../types/claim';
import { CLAIM_STEPS } from './Constants';

export const configureClaimsPayload = (
    data: Partial<ClaimsFormData>,
    activeStep: number
): Partial<ClaimsFormData> => {
    const stepsPayloads: Record<number, Partial<ClaimsFormData>> = {
        [CLAIM_STEPS.STEP_1]: {
            company_id: data.company_id,
            account_number: data.account_number,
            toshiba_installation_id: data.toshiba_installation_id,
            installation_date: data.installation_date,
            customer_id: data.customer_id,
            distributor_id: data.distributor_id,
        },
        [CLAIM_STEPS.STEP_2]: {
            // Context fields from Step 1 (needed for conditional validation)
            distributor_id: data.distributor_id,
            toshiba_installation_id: data.toshiba_installation_id,
            // Step 2 fields
            toshiba_installation_system_id: data.toshiba_installation_system_id,
            product_child_id: data.product_child_id,
            product_type_id: data.product_type_id,
            product_line_id: data.product_line_id,
            product_id: data.product_id,
            serial_number: data.serial_number,
            dispatch_note_number: data.dispatch_note_number,
            date_of_failure: data.date_of_failure,
            date_of_repair: data.date_of_repair,
            proposed_date_of_repair: data.proposed_date_of_repair,
            quantity_of_parts: data.quantity_of_parts,
        },
        [CLAIM_STEPS.STEP_3]: {
            // Context field from Step 1 (needed for conditional validation)
            distributor_id: data.distributor_id,
            // Step 3 fields
            parts: data.parts,
        },
        // Step 4 - Summary (read-only, no payload needed)
        [CLAIM_STEPS.STEP_4]: {},
    };

    return stepsPayloads[activeStep] || {};
};
